import { useTheme } from "./ThemeProvider";
import "./ThemeToggle.css";

export const ThemeToggle = ({ className = "" }: { className?: string }) => {
	const { theme, toggleTheme } = useTheme();

	return (
		<button
			type="button"
			onClick={toggleTheme}
			className={`theme-toggle ${className}`}
			title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
		>
			<span className="theme-toggle-icon">
				{theme === "light" ? "🌙" : "☀️"}
			</span>
		</button>
	);
};
